import type { Board } from "@/lib/types";

// F1: sort boards by the user's custom order_position (ascending), with
// un-positioned boards (null) falling back to the alphabetical default and
// always sorting AFTER explicitly-ordered ones.
export function compareBoardOrder(a: Board, b: Board): number {
  const pa = a.order_position;
  const pb = b.order_position;
  if (pa != null && pb != null) return pa - pb;
  if (pa != null) return -1;
  if (pb != null) return 1;
  return a.name.localeCompare(b.name, "de");
}

// Re-index a reordered board list to concrete positions. We rewrite the WHOLE
// visible list (not just the moved board) on each drop: most boards start
// un-positioned (null → name-sorted), so seeding every one captures the full
// intended order and keeps subsequent sorts stable. Cheap (a workspace has few
// boards) and avoids null-neighbour midpoint gaps.
export function reindexPositions(ordered: Board[]): { board_id: string; position: number }[] {
  return ordered.map((b, i) => ({ board_id: b.id, position: (i + 1) * 1000 }));
}
